export default {
  tooltip: {
    trigger: "axis",
  },
  legend: {
    data: ["热泵", "水泵", "变频器", "其他"],
    icon: "circle",
    itemWidth: 10,
    itemHeight: 10,
    bottom: 0,
    textStyle: {
      color: "#fff",
    },
  },
  grid: {
    top: 0,
    left: "3%",
    right: "4%",
    bottom: "13%",
    containLabel: true,
  },
  xAxis: {
    type: "category",
    boundaryGap: true,
    data: [],
    axisLabel: {
      color: "#fff",
    },
    axisLine: {
      lineStyle: {
        color: "#fff",
        opacity: 0.4,
      },
    },
    axisTick: {
      show: false,
    },
  },
  yAxis: {
    type: "value",
    axisLabel: {
      color: "#fff",
      rotate: 30,
    },
    axisLine: {
      show: false,
    },
    splitLine: {
      show: true,
      lineStyle: {
        opacity: 0.4,
      },
    },
  },
  series: [],
};
